import type { CopilotChatUserMessageProps } from '@copilotkit/react-core/v2';
import { InkAiUserMessage } from '@movable/ui';
import { Box } from '@mui/material';

export const InkUserMessageSlot = ({
  message,
}: CopilotChatUserMessageProps) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', pl: '36px' }}>
    <InkAiUserMessage
      content={typeof message.content === 'string' ? message.content : ''}
    />
  </Box>
);
